
  import { css } from 'lit';
  export const styles = css`:host{--stroke-thickness: 3px;--scale-factor: 3.4}[part~=fill]{stroke-width:var(--stroke-thickness)}`;
  